import { render } from "./purchasesBillAdd.vue?vue&type=template&id=6f3a758c&scoped=true"
import script from "./purchasesBillAdd.vue?vue&type=script&lang=js"
export * from "./purchasesBillAdd.vue?vue&type=script&lang=js"

import "./purchasesBillAdd.vue?vue&type=style&index=0&id=6f3a758c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3a758c"]])

export default __exports__